import { Box } from 'braid-design-system';
import type { ReactNode } from 'react';

import * as styles from './ProfileMenuItem.css';

export const ProfileMenuItem = ({
  children,
  onClick,
}: {
  children: ReactNode;
  onClick?: () => void;
}) => (
  <Box
    paddingRight="medium"
    paddingLeft="medium"
    paddingTop="small"
    paddingBottom="small"
    onClick={onClick}
    className={styles.profileMenuItem}
  >
    {children}
  </Box>
);
